function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 7.42053C19.448 7.66146 18.855 7.82429 18.2325 7.89754C18.8679 7.52263 19.3558 6.92893 19.5856 6.22155C18.9815 6.57442 18.3206 6.82305 17.6314 6.95667C17.07 6.36794 16.2703 6 15.3851 6C13.6855 6 12.3076 7.35639 12.3076 9.02933C12.3076 9.2668 12.3348 9.49798 12.3873 9.71975C9.82965 9.59338 7.56207 8.38736 6.0442 6.55453C5.77936 7.00195 5.6276 7.52239 5.6276 8.0775C5.6276 9.12854 6.17094 10.0557 6.99664 10.599C6.50794 10.584 6.02999 10.454 5.6027 10.2201C5.60252 10.2328 5.60252 10.2454 5.60252 10.2582C5.60252 11.726 6.6633 12.9504 8.07107 13.2287C7.6179 13.35 7.14256 13.3678 6.68135 13.2806C7.07293 14.4841 8.20947 15.3599 9.55607 15.3845C8.50285 16.1969 7.17588 16.6813 5.73412 16.6813C5.48568 16.6813 5.24076 16.6669 5 16.6389C6.36189 17.4985 7.97949 18 9.71738 18C15.3779 18 18.4733 13.3838 18.4733 9.38066C18.4733 9.24926 18.4704 9.11862 18.4644 8.98872C19.0669 8.55998 19.5869 8.02894 20 7.42053Z",
  fill: "#ED0F77"
});

var SvgTwitterPink = function SvgTwitterPink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitterPink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter-pink.b87233e7.svg";
export { ForwardRef as ReactComponent };